import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import GoogleButton from "../components/GoogleButton";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { COACH_GYM, LOGO } from "../lib/brand";

const HERO = COACH_GYM;

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin" : "/app");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={HERO} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="absolute bottom-12 left-12 text-white">
          <img src={LOGO} alt="Being Fit For You" className="h-20 w-20 rounded-xl bg-black/60 object-contain p-2 mb-4" />
          <div className="font-display font-900 uppercase text-6xl leading-[0.9]">Being<span className="text-primary">Fit</span><br />ForYou</div>
          <p className="text-xs uppercase tracking-[0.25em] text-white/70 mt-4">Fitness for every body. Every goal.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-sm">
          <Link to="/" className="text-xs uppercase tracking-[0.15em] text-muted-foreground hover:text-primary transition-colors">← Back to site</Link>
          <h1 className="font-display font-900 uppercase text-5xl tracking-tight mt-6">Welcome back</h1>
          <p className="text-muted-foreground mt-2 text-sm">Log in to your BeingFitForYou account.</p>
          <div className="mt-7"><GoogleButton /></div>
          <div className="flex items-center gap-4 my-6"><div className="h-px bg-border flex-1" /><span className="text-xs uppercase tracking-widest text-muted-foreground">or</span><div className="h-px bg-border flex-1" /></div>
          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div><Label className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12" /></div>
            <div><Label className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-12" /></div>
            <button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-primary text-primary-foreground py-3.5 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.02] transition-transform disabled:opacity-60">{busy ? "Signing in…" : "Log In"}</button>
          </form>
          <p className="text-sm text-muted-foreground mt-6 text-center">No account? <Link to="/register" className="text-primary font-bold">Create one free</Link></p>
        </div>
      </div>
    </div>
  );
}
